// components
import { styled, Box, BoxProps, Alert, AlertProps } from '@mui/material';

export const StyledDayLimitBaseBox = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'grid',
  gap: theme.spacing(2)
}));

export const StyledRecordsBox = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(2)
}));

export const StyledRecordsInnerBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: theme.spacing(1)
}));

export const StyledDayLimitErrorAlert = styled(Alert)<AlertProps>(
  ({ theme }) => ({
    marginTop: theme.spacing(-4),
    marginBottom: theme.spacing(4)
  })
);

export const StyledNoRowsBox = styled(Box)<BoxProps>(({ theme }) => ({
  padding: theme.spacing(6, 2),
  marginTop: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius
}));
